import { useAuthenticatedQuery } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { speedingsQueryKeys } from "./queryKeys"

export function useTrafficStats(params = {}, config = {}) {

    const baseUrl = "traffic/traffics/stats"
    const lightVehicleUrl = `${baseUrl}/average_light_vehicle_count/`
    const heavyVehicleUrl = `${baseUrl}/average_heavy_vehicle_count/`
    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()

    const {
        data: lightVehicleCount,
        isLoading: isLightVehicleCountLoading,
        isError: isLightVehicleCountError,
    } = useAuthenticatedQuery(
        lightVehicleUrl,
        speedingsQueryKeys.lightSpeedLimitsStats(params),
        { ...params, project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
    )

    const { data: heavyVehicleCount,
        isLoading: isHeavyVehicleCountLoading,
        isError: isHeavyVehicleCountError,
    } = useAuthenticatedQuery(
        heavyVehicleUrl,
        speedingsQueryKeys.heavySpeedLimitsStats(params),
        { ...params, project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled,
        },
    )

    return {
        data: {
            ...lightVehicleCount,
            ...heavyVehicleCount,
        },
        isLoading: isLightVehicleCountLoading || isHeavyVehicleCountLoading,
        isError: isLightVehicleCountError || isHeavyVehicleCountError,
    }

}